import { CheckCircle2, type LucideIcon, Power, Snowflake } from 'lucide-react';
import type { StatusChipVariant } from '@/components/ui/status-chip';
import type { ExchangeStatus } from '@/services/api/exchange';

interface ExchangeStatusMeta {
  label: string;
  icon: LucideIcon;
  variant: StatusChipVariant;
  dotClass: string;
  textClass: string;
}

export const EXCHANGE_STATUS_META: Record<ExchangeStatus, ExchangeStatusMeta> = {
  active: { label: 'Active', icon: CheckCircle2, variant: 'success', dotClass: 'bg-emerald-500', textClass: 'text-emerald-500' },
  frozen: { label: 'Frozen', icon: Snowflake, variant: 'warning', dotClass: 'bg-amber-500', textClass: 'text-amber-500' },
  disabled: { label: 'Disabled (Killswitch Activated)', icon: Power, variant: 'destructive', dotClass: 'bg-red-500', textClass: 'text-red-500' },
};
